/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverapppreviewevent3Inputs */

const en_coverapppreviewevent3 = /** @type {(inputs: Coverapppreviewevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event page`)
};

const de_coverapppreviewevent3 = /** @type {(inputs: Coverapppreviewevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventseite`)
};

/**
* | output |
* | --- |
* | "Event page" |
*
* @param {Coverapppreviewevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverapppreviewevent3 = /** @type {((inputs?: Coverapppreviewevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverapppreviewevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverapppreviewevent3(inputs)
	return de_coverapppreviewevent3(inputs)
});
export { coverapppreviewevent3 as "coverAppPreviewEvent" }